function transformReviewText(el) {
  const number = el.textContent.match(/\d+/);
  if (number) {
    el.textContent = `(${number[0]})`;
  }
}

const observer = new MutationObserver(() => {
  if (window.innerWidth > 849) return;

  document.querySelectorAll('.yotpo-sr-bottom-line-text').forEach(el => {
    if (!el.dataset.reviewModDone) {
      el.dataset.reviewModDone = 'true';
      transformReviewText(el);
    }
  });

  document.querySelectorAll('.yotpo-sr-bottom-line-score').forEach(el => {
    if (!el.dataset.reviewModDone) {
      el.dataset.reviewModDone = 'true';
      const score = el.textContent.trim();
      if (score) {
        el.textContent = `${score}/5`;
      }
    }
  });
});

observer.observe(document.body, { childList: true, subtree: true });